module.exports = __webpack_public_path__ + "static/media/Python-logo-notext.a919f106.svg";